import {useEffect, useRef} from 'react'
import {Legend, StyledTypography, StyledTitleTypography, StyledInnerDiv, StyledOuterDiv} from './POILegendStyle'
import {useConfig} from '../../../../../store/hooks/config'
import {usePointOfInterest} from '../../../../../store/hooks/pointOfInterest'
import {useExport} from '../../../../../store/hooks/export'
import {Box} from '@mui/material'
import {toPng} from 'html-to-image'
import {getPOIImageUrl} from '../../../helper'

const POILegendComponent = () => {
  const {selectedPOI, existingPOI} = usePointOfInterest()
  const {POIConfig: poiConfig} = useConfig() || {}
  const poiLegendRef = useRef()
  const {setPoiImageData} = useExport()

  useEffect(() => {
    const scale = 4

    toPng(poiLegendRef.current, {
      width: poiLegendRef.current.clientWidth * scale,
      height: poiLegendRef.current.clientHeight * scale,
      style: {transform: 'scale(' + scale + ')', transformOrigin: 'top left'},
      skipFonts: true
    }).then((dataUrl) => {
      setPoiImageData(dataUrl)
    })
    return () => {
      setPoiImageData('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPOI])

  return (
    <StyledOuterDiv id='hp-poi-legend-container'>
      <Box ref={poiLegendRef}>
        <StyledTitleTypography variant='labelMedium'>Points of Interest Legend</StyledTitleTypography>
        {selectedPOI.map((poi) => {
          if (!poiConfig?.[poi]) {
            return null
          }
          const label =
            existingPOI?.find((existingPoi) => existingPoi.value === poi)?.customLabel || poiConfig[poi].label
          return (
            <StyledInnerDiv key={poi}>
              <Legend alt={`${poi.label} icon`} src={getPOIImageUrl(poiConfig[poi].markerProps.iconURL)} />
              <StyledTypography variant='body2'>{label}</StyledTypography>
            </StyledInnerDiv>
          )
        })}
      </Box>
    </StyledOuterDiv>
  )
}

export default POILegendComponent

/**
 * List of functions and their purpose:
 *
 * - POILegendComponent: Renders a legend for points of interest (POI) with icons and labels, and exports it as an image.
 */
